import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { CustomerLegalForm } from "../../core/model/customer-legal-form";
import { CustomerLegalFormService } from "../../core/service/customer-legal-form.service";

@Component({
  selector: "app-add-legal-form",
  templateUrl: "./add-legal-form.component.html",
  styleUrls: ["./add-legal-form.component.scss"],
})
export class AddLegalFormComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  customerLegalForm: CustomerLegalForm = new CustomerLegalForm();

  constructor(
    private _router: Router,
    private _customerLegalFormService: CustomerLegalFormService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      label: [
        "",
        [Validators.compose([Validators.required]), Validators.maxLength(50)],
      ],
    });
  }

  ngOnInit() {}

  save(): void {
    this._customerLegalFormService
      .add(this.customerLegalForm)
      .pipe(first())
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/legal-form");
  }
}
